export default "__VITE_ASSET__40c3ee98__"